
<sm-title-bar [pageTitle]="bookingType == '0' ? 'Home Bookings & Query' : (bookingType == '1' ? 'Shop Bookings & Query' : 'Virtual Bookings & Query')" [backWithParams]="true" 
[headerCustomTemplate]="addButton">


  <ng-template #addButton>
    <div class="d-flex search-field">
     

  
    </div>
  </ng-template>
</sm-title-bar>

<div class="chip_cont">
  <div class="booing_sectyy">
  <mat-chip-list aria-label="Fish selection" class="mb-3">
    <mat-chip
      style="height: auto"
      [ngClass]="{ selected: selectedValue == '0' }"
      (click)="changeChip('0')"
      >{{ 'business_bookings.today' | translate }}
    </mat-chip>
  </mat-chip-list>

  <mat-chip-list aria-label="Fish selection" class="mb-3">  
    <mat-chip
      style="height: auto"
      [ngClass]="{ selected: selectedValue == '1' }"
      (click)="changeChip('1')"
      >{{ 'business_bookings.tomorrow' | translate }}
    </mat-chip>
  </mat-chip-list>
  <mat-chip-list aria-label="Fish selection" class="mb-3">  
    <mat-chip
      style="height: auto"
      [ngClass]="{ selected: selectedValue == '2' }"
      (click)="changeChip('2')"
      >Membership request
    </mat-chip>
  </mat-chip-list>
  <mat-chip-list aria-label="Fish selection" class="mb-3">  
    <mat-chip
      style="height: auto"
      [ngClass]="{ selected: selectedValue == '3' }"
      (click)="changeChip('3')"
      >Customer queries
    </mat-chip>
  </mat-chip-list>

</div>

  <div class="booking_sectionkl">
  <!-- <div class="Create_header_btn">
    <button mat-flat-button color="primary" (click)="createNewBooking()"> <mat-icon>add</mat-icon> Booking</button>
 </div> -->

 <!-- <div class="Create_header_btn">
  <button mat-flat-button color="primary" (click)="createInvoice()"> <mat-icon>add</mat-icon> Bill / Invoice</button>
 </div> -->

  <div class="Create_header_btn">
        <button
          mat-flat-button
          color="primary"
          [matMenuTriggerFor]="addMenu">
          <mat-icon>add</mat-icon>
          Add new
        </button>
        </div>
        <!-- Menu -->

        <mat-menu #addMenu="matMenu">
          <button mat-menu-item  (click)="createNewBooking()">
            <mat-icon>event</mat-icon>
            <span>New booking</span>
          </button>
          <button mat-menu-item (click)="addNewInterest()">
            <mat-icon>card_membership</mat-icon>
            <span>New membership request</span>
          </button>
        </mat-menu>

 <div class="booking_sedr">
  <button mat-flat-button color="primary" (click)="refreshScreen()">
    <mat-icon class="material-icons-round" [inline]="true" style="font-size: 22px; position: relative; top: 0px;">refresh</mat-icon>
</button>
</div>
</div>
  
</div>

<div *ngIf="loader" class="loader">
  <mat-spinner></mat-spinner>
</div>
<mat-card *ngIf="visible && !loader && bookingsData.length > 0 && (selectedValue == '0' || selectedValue == '1')">
  <mat-card-header class="justify-content-between align-items-center mb-3">
  </mat-card-header>
  <div class="rounded-3 bg-light">
    <sm-data-table-for-appointments
      [columnHeaders]="tableDisplayColumns"
      [dataSource]="bookingsData"
      [showPagination]="true"
      [itemsPerPage]="25"
      [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate"
             [rowClickHandler]="rowClickHandler"
    >

    <ng-template #costTemplate let-rowVal="row" let-colVal="col">
      {{rowVal[colVal.columnProperty] | currency: 'INR'}}
    </ng-template>
    </sm-data-table-for-appointments>
  </div>
</mat-card>

<ng-template #menuTemplate let-rowvalue>
  <button mat-menu-item (click)="bookingDetails(rowvalue)">
    <mat-icon class="material-icons-outlined">info</mat-icon>
    <span>{{ 'business_bookings.opt_booking_details' | translate }}</span>
  </button>
    <!-- <button mat-menu-item *ngIf="((rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2) && (rowvalue.customerInfo.hash_id && rowvalue.customerInfo.hash_id != 'null'))" (click)="confirmBooking(rowvalue)">
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      <span>{{ 'business_bookings.opt_confirm_booking' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 7 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 5) && selectedValue == '0'" (click)="startProcess(rowvalue)">
      <mat-icon class="material-icons-outlined">timer</mat-icon>
      <span>{{ 'business_bookings.opt_start_process' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 7 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 5)  && isOwner  && selectedValue == '0'" (click)="assignJob(rowvalue)">
      <mat-icon class="material-icons-outlined">assignment_ind</mat-icon>
      <span>{{ 'business_bookings.opt_assign_job' | translate }}</span>
    </button>
    
    <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 5)  && selectedValue == '0'" (click)="done(rowvalue)">
      <mat-icon class="material-icons-outlined">task_alt</mat-icon>
      <span>{{ 'business_bookings.opt_done' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 4) && isOwner && selectedValue == '0'" (click)="customiseBooking(rowvalue)">
      <mat-icon class="material-icons-outlined">tune</mat-icon>
      <span>Edit data</span>
    </button>
    <button mat-menu-item *ngIf="(rowvalue.bookingStatus != 4 && rowvalue.bookingStatus != 6 && rowvalue.bookingStatus != 8) && bookingType == '2'" (click)="addEditMeetingData(rowvalue)">
      <mat-icon class="material-icons-outlined">video_chat</mat-icon>
      <span>Meeting info</span>
    </button>
    <button mat-menu-item *ngIf="(rowvalue.bookingStatus == 3 || rowvalue.bookingStatus == 9 || rowvalue.bookingStatus == 4 || rowvalue.bookingStatus == 7)  && isOwner  && selectedValue == '0'" (click)="reset(rowvalue)">
      <mat-icon class="material-icons-outlined">restart_alt</mat-icon>
      <span>{{ 'business_bookings.opt_reset_to_new' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="rowvalue.bookingStatus == 4 && selectedValue == '0'" (click)="openInvoice(rowvalue)">
      <mat-icon class="material-icons-outlined">receipt_long</mat-icon>
      <span>{{ 'business_bookings.opt_invoice' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="((rowvalue.bookingStatus == 0 || rowvalue.bookingStatus == 1 || rowvalue.bookingStatus == 2 || rowvalue.bookingStatus == 5) && isOwner )" (click)="cancelBooking(rowvalue)">
      <mat-icon class="material-icons-outlined">cancel</mat-icon>
      <span>{{ 'business_bookings.opt_cancel_booking' | translate }}</span>
    </button>
    <button mat-menu-item *ngIf="(!rowvalue.customerInfo.hash_id || rowvalue.customerInfo.hash_id == 'null') && isOwner  && selectedValue == '0'" (click)="deleteBooking(rowvalue)">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Delete booking</span>
    </button> -->
  </ng-template> 



  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="visible && !loader && bookingsData.length == 0 && (selectedValue == '0' || selectedValue == '1')">
        <div class="row">
          <div class="col-sm-4" *ngIf="selectedValue == '0'">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/bookings-pp.png">
                 </div>
                 <mat-card-title>No bookings for today.</mat-card-title>
                 <mat-card-content>There's no booking done by any customer or from the house for today. Though you can create one from here.

                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="createNewBooking()">
                      <mat-icon>add</mat-icon>
                      New booking
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4" *ngIf="selectedValue == '1'">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/bookings-pp.png">
                 </div>
                 <mat-card-title>No bookings for tomorrow.</mat-card-title>
                 <mat-card-content>For any difficulties in creating a new business or if there's any issue with subscription, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="createNewBooking()">
                       <mat-icon>add</mat-icon>
                       New booking
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="/assets/images/new-booking.png">
                 </div>
                 <mat-card-title>How to create a new booking?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new booking against a business. You can check this video as well. 

                </mat-card-content>
                <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="openvideo()">
                     <mat-icon>play_arrow</mat-icon>
                     Watch video
                  </button>
               </div>
                 </div>
              </mat-card>
           </div>
          </div>
       
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in creating a new booking or in issue in getting booking list data, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
  </div> 
  <!-- placeholder html end -->



  <!-- MEMBERSHIP QUERIES START -->
<mat-card style="margin-bottom: 10px;" *ngIf="visible && !loader && interestData.length > 0  && selectedValue == '2'">

   <div class="rounded-3 bg-light" >
      <sm-data-table-for-appointments
      [columnHeaders]="tableDisplayColumnsforquery"
      [dataSource]="interestData"
      [showPagination]="true"
      [itemsPerPage]="25"
      [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate"
      [rowClickHandler]="rowClickHandlerforquery"
      >
      <ng-template #costTemplate let-rowVal="row" let-colVal="col">
        adas
      </ng-template>
      </sm-data-table-for-appointments>
   </div>
</mat-card>


<ng-template #menuTemplate let-rowvalue>
   <div>
   <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
      </button>
   <!-- <button mat-menu-item (click)="addReply(rowvalue)" *ngIf="rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">reply</mat-icon>
   <span>Reply</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,1)" *ngIf="rowvalue.enrollment_request_status != 1 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">grade</mat-icon>
   <span>Mark as new</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,2)" *ngIf="rowvalue.enrollment_request_status != 2 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">hourglass_top</mat-icon>
   <span>Mark as in-progress</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,3)" *ngIf="rowvalue.enrollment_request_status != 3 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">task_alt</mat-icon>
   <span>Mark as enrolled</span>
   </button>
   <button mat-menu-item (click)="changeRequestStatus(rowvalue,4)" *ngIf="rowvalue.enrollment_request_status != 4 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">cancel</mat-icon>
   <span>Mark as cancelled</span>
   </button>
   <button mat-menu-item (click)="addAsMember(rowvalue)" *ngIf="rowvalue.enrollment_request_status == 3 &&  rowvalue.enrollment_request_status != 5 && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">person_add</mat-icon>
   <span> Add in enrolled members</span>
   </button>
   <button mat-menu-item (click)="deleteQuery(rowvalue)" *ngIf="(!rowvalue.customer_account_hash ||  rowvalue.customer_account_hash == 'null') && (isOwner || interestType != '4')">
   <mat-icon class="material-icons-outlined">delete</mat-icon>
   <span> Delete query</span>
   </button> -->
</div>
 

</ng-template>
<!-- placeholder html start -->
<div class="placeholder_started" *ngIf="visible && !loader && interestData.length == 0  && selectedValue == '2'">
   <div class="row">
      <div class="col-sm-4" >
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/query-s1.jpg">
                  </div>
                  <mat-card-title>No queries to show.</mat-card-title>
                  <mat-card-content>All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
                  </mat-card-content>
                  <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
               </div>
            </mat-card>
         </div>
      </div>

      <div class="col-sm-4">
         <div class="dashboard_new">
           <mat-card>
               <div class="upload_sectio">
              <div class="icm_img">
                 <img src="/assets/images/new-booking.png">
              </div>
              <mat-card-title>How to create a new query?</mat-card-title>
              <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new query against a business. You can check this video as well. 

             </mat-card-content>
             <div class="watch_vc_btn">
               <button mat-stroked-button color="primary" (click)="openvideo()">
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
               </button>
            </div>
              </div>
           </mat-card>
        </div>
       </div>
      <div class="col-sm-4">
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/helpsupport.png">
                  </div>
                  <mat-card-title>Facing any issue?</mat-card-title>
                  <mat-card-content>For any difficulties in adding a new query or issue with managing them, contact our support team.
                  </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary"  (click)="opencontact()">
                        <mat-icon>support_agent</mat-icon>
                        Contact support 
                     </button>
                  </div>
               </div>
            </mat-card>
         </div>
      </div>
   </div>
</div>
<!-- placeholder html end -->


<!-- MEMBERSHIP QUERIES END -->











  <!--  QUERIES START -->
<mat-card style="margin-bottom: 10px;" *ngIf="visible && !loader && queryData.length > 0  && selectedValue == '3'">

   <div class="rounded-3 bg-light" >
      <sm-data-table-for-appointments
      [columnHeaders]="tableDisplayColumnsforserviceQuery"
      [dataSource]="queryData"
   [showPagination]="true"
      [itemsPerPage]="25"
      [showMenuButton]="true"
      [menuDropdownTemplate]="menuTemplate"
      [rowClickHandler]="rowClickHandlerforservicequery"
      >
      <ng-template #costTemplate let-rowVal="row" let-colVal="col">
        adas
      </ng-template>
      </sm-data-table-for-appointments>
   </div>
</mat-card>


<ng-template #menuTemplate let-rowvalue>
   <div>
   <button mat-menu-item (click)="viewDetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
      </button>
  
</div>
 

</ng-template>
<!-- placeholder html start -->
<div class="placeholder_started" *ngIf="visible && !loader && queryData.length == 0  && selectedValue == '3'">
   <div class="row">
      <div class="col-sm-4" >
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/query-s1.jpg">
                  </div>
                  <mat-card-title>No service queries to show.</mat-card-title>
                  <mat-card-content>All the queries will appear here between the selected date range. It seems you haven't started operations or check the selected dates.
                  </mat-card-content>
                  <!-- <div class="watch_vc_btn" *ngIf="interestType != '4'">
                     <button mat-stroked-button color="primary"  (click)="addNewInterest()">
                        <mat-icon>add</mat-icon>
                        Add new query 
                     </button>
                  </div> -->
               </div>
            </mat-card>
         </div>
      </div>

      <!-- <div class="col-sm-4">
         <div class="dashboard_new">
           <mat-card>
               <div class="upload_sectio">
              <div class="icm_img">
                 <img src="/assets/images/new-booking.png">
              </div>
              <mat-card-title>How to create a new query?</mat-card-title>
              <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating new query against a business. You can check this video as well. 

             </mat-card-content>
             <div class="watch_vc_btn">
               <button mat-stroked-button color="primary" (click)="openvideo()">
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
               </button>
            </div>
              </div>
           </mat-card>
        </div>
       </div> -->
      <div class="col-sm-4">
         <div class="dashboard_new">
            <mat-card>
               <div class="upload_sectio">
                  <div class="icm_img">
                     <img src="./assets/images/helpsupport.png">
                  </div>
                  <mat-card-title>Facing any issue?</mat-card-title>
                  <mat-card-content>For any difficulties contact our support team.
                  </mat-card-content>
                  <div class="watch_vc_btn">
                     <button mat-stroked-button color="primary"  (click)="opencontact()">
                        <mat-icon>support_agent</mat-icon>
                        Contact support 
                     </button>
                  </div>
               </div>
            </mat-card>
         </div>
      </div>
   </div>
</div>
<!-- placeholder html end -->


<!--  QUERIES END -->